import React, { useState, useEffect } from "react";
import { Column, DataGrid } from "devextreme-react/data-grid";
import { api_path } from "../../shared";

const CustomerSalesIncharge = ({ CUSTOMER_CODE, onEdit }) => {
  const token = process.env.REACT_APP_API_TOKEN;
  const url = api_path + "/customer/sales-owner.php";
  const [dataSource, setDataSource] = useState([]);
  const [selectedRowKey, setSelectedRowKey] = useState(null); // track row ที่เลือก

  useEffect(() => {
    const fetchData = async () => {
      if (!CUSTOMER_CODE) {
        setDataSource([]);
        return;
      }

      try {
        const res = await fetch(`${url}?CUSTOMER_CODE=${CUSTOMER_CODE}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        if (!res.ok) {
          setDataSource([]);
          return;
        }

        let data = await res.json();

        if (!data || (typeof data !== "object" && !Array.isArray(data))) {
          data = [];
        } else if (!Array.isArray(data)) {
          data = [data];
        }

        setDataSource(data);
      } catch (error) {
        console.error("Error loading data:", error);
        setDataSource([]);
      }
    };

    fetchData();
  }, [CUSTOMER_CODE, token, url]);

  const onEditButtonClick = (rowData) => {
    setSelectedRowKey(rowData.CUSTOMER_ITEM_ID); // เซ็ต row ที่เลือก
    if (onEdit) {
      onEdit({
        SELECT_SALES_ID: rowData.SALES_ID,
        SELECT_SALESNAME: rowData.USER_EMAIL,
      });
    }
  };

  return (
    <div>
      <br />
      <label className="head2">Sales In-charge</label>
      <DataGrid
        dataSource={dataSource}
        keyExpr="CUSTOMER_ITEM_ID"
        showBorders={false}
        noDataText="No Sales In-charge"
        onRowPrepared={(e) => {
          if (e.rowType === "data") {
            // ไฮไลต์ row ที่เลือก
            if (e.data.CUSTOMER_ITEM_ID === selectedRowKey) {
              e.rowElement.style.backgroundColor = "rgba(0, 120, 212, 0.2)";
            } else {
              e.rowElement.style.backgroundColor = "";
            }

            // สี ACTIVE_STATUS
            const activeCell = e.rowElement.querySelector(
              '[aria-colindex="' +
                (e.component.getVisibleColumns().findIndex(c => c.dataField === "ACTIVE_STATUS") + 1) +
                '"]'
            );
            if (activeCell) {
              if (e.data.ACTIVE_STATUS === "ACTIVE") activeCell.style.color = "green";
              if (e.data.ACTIVE_STATUS === "INACTIVE") activeCell.style.color = "red";
              activeCell.style.fontWeight = "bold";
            }
          }
        }}
      >
        <Column dataField="CUSTOMER_ITEM_ID" visible={false} />
        <Column dataField="SALES_ID" width={50} />
        <Column dataField="SALESNAME" width={220} />
        <Column dataField="USER_EMAIL" caption="EMAIL" width={220} />
        <Column dataField="CUSTOMER_MASTER_EN" caption="TIER" />
        <Column dataField="ACTIVE_STATUS" caption="ACTIVE STATUS" />
        <Column
          caption="Edit"
          width={50}
          cellRender={(cellData) => (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                height: "100%",
              }}
            >
              <button
                style={{
                  backgroundColor: "gray",
                  color: "white",
                  border: "none",
                  padding: "5px 10px",
                  borderRadius: "4px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                title="Edit"
                onClick={() => onEditButtonClick(cellData.data)}
              >
                <span className="dx-icon dx-icon-edit" style={{ fontSize: "16px" }}></span>
              </button>
            </div>
          )}
        />
      </DataGrid>
    </div>
  );
};

export default CustomerSalesIncharge;
